import BaseModel from "./base/baseModel";

export default class MotivoCancelamentoModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
    ativo = true;
    exigirObservacao = true;
}
